import { Component, input } from '@angular/core';
import {
  GcTagComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-installation-report-object-header',
  imports: [GcTextComponent, GcTagComponent, IpoTranslatePipe],
  templateUrl: './installation-report-object-header.component.html',
  styleUrl: './installation-report-object-header.component.scss',
})
export class InstallationReportObjectHeaderComponent {
  address = input.required<string>();
  isNotApplicable = input(false);
}
